module.exports = __webpack_public_path__ + "static/media/ar-button.170c9bf9.svg";